import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import Settings from "../views/Settings";
import Orders from "../views/Orders";
import Payments from "../views/Payments";
import Payment from "../views/Payment";
import Support from "../views/Support";
import CreateOrder from "../views/CreateOrder";
import Remains from "../views/Remains";
import NotFound from "../views/404";
import store from '@/store'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: 'orders',
        name: 'home',
        component: Home,
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                meta: {
                    'title': 'drop_stat_title'
                },
                component: Dashboard,
            },
            {
                path: 'orders',
                name: 'orders',
                meta: {
                    'title': 'drop_orders'
                },
                component: Orders,
            },
            {
                path: 'payments',
                name: 'payments',
                meta: {
                    'title': 'drop_payments'
                },
                component: Payments,
            },
            {
                path: 'remains',
                name: 'remains',
                meta: {
                    'title': 'drop_renains_and_photos'
                },
                component: Remains,
            },
            {
                path: 'order',
                name: 'order',
                meta: {
                    'title': 'drop_new_order'
                },
                component: CreateOrder,
            },
            {
                path: 'payment',
                name: 'payment',
                meta: {
                    'title': 'drop_add_money'
                },
                component: Payment,
            },
            {
                path: 'support',
                name: 'support',
                meta: {
                    'title': 'drop_support'
                },
                component: Support,
            },
            {
                path: 'settings',
                name: 'settings',
                meta: {
                    'title': 'drop_settings'
                },
                component: Settings,
            },
        ]
    }, {
        path: '/login',
        name: 'login',
        meta: {
            'title': 'drop_auth_title'
        },
        component: Login,
    },
    {
        path: '*',
        name: 'notfound',
        meta: {
            'title': 'drop_drop_404_title'
        },
        component: NotFound,
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes
})
router.beforeEach((to, from, next) => {
    // console.log(to, from)
    document.title = (store.state.lexicon[to.meta.title]? store.state.lexicon[to.meta.title]+' | ' :'') + 'Dropshipping Brushme'
    if (to.name != 'login' && !store.getters['auth/authenticated']) {
        return next({
            'name': 'login'
        })
    } else if (to.name == 'login' && store.getters['auth/authenticated']) {
        return next({
            'name': 'home'
        })
    }
    next();
})
export default router
